import { AxiosResponse } from 'axios';
import HttpStatus from 'model/enums/httpStatus';

import { markError } from 'reducer/application/error/actions';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import accountApi from 'services/api/accountApi';
import { ErrorUtils } from 'shared/error/error-utils';
import { changePasswordError, changePasswordRequest, changePasswordSuccess } from './actions';
import { ChangePasswordActionTypes } from './types';


function* handleChangePassword(action: ReturnType<typeof changePasswordRequest>) {
    try {
        const result: AxiosResponse<void> = yield call(accountApi.hasChangedPasswordProfile, action.payload);
        if (result.status !== HttpStatus.OK) {
            const mapped = ErrorUtils.mapGiroIdhApiError(result);
            yield put(markError(mapped));
            yield put(changePasswordError(mapped));
            return;
        }
        yield put(changePasswordSuccess(result.data));
    } catch (error) {
        const mapped = ErrorUtils.mapLocalError(error);
        yield put(markError(mapped));
        yield put(changePasswordError(mapped));
    }
}

function* watchChangePassword() {
    yield takeEvery(ChangePasswordActionTypes.CHANGE_PASSWORD_REQUEST, handleChangePassword);
}

function* changePasswordSaga() {
    yield all([fork(watchChangePassword)]);
}

export default changePasswordSaga;
